import React, { Component } from "react";
import Slider from "../components/Slider";
import LazyLoad from "react-lazyload";
import { Link } from "react-router";
import "../css/youtube.css";

class ArtGalleryMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentWillMount() {
    var arr = [];
    var thisState = this;
    fetch("/api/getartwork", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ exhibition_name: this.props.art })
    })
      .then(resp => resp.json())
      .then(function(data) {
        arr = Object.keys(data.art).map(function(obj) {
          return data.art[obj];
        });
        thisState.setState({ data: arr });
      });
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.props.painting) {
        document.getElementById(this.props.painting).scrollIntoView(true);
        window.scrollBy(0, -40);
      }
    }, 700)
  }


  handleCurrentSlide(event) {
    this.setState({ currentSlide: event });
  }

  labnolIframe(container_id, id) {
    var img = document.getElementById(container_id);
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?autoplay=1&VQ=HD720";
    iframe.setAttribute("src", embed.replace("ID", id));
    iframe.setAttribute("height", "440");
    iframe.setAttribute("width", "720");
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    img.replaceWith(iframe);
  }
  render() {
    var obj = this;
    return (
      <div className="art-gallery">
        {this.state.data.map(function(object, k) {
          var fnameArr = object.painting_oid.split(",");
          var imagesArr = object.paintings.split(",");
          imagesArr.push(imagesArr[0]);
          fnameArr.push(fnameArr[0]);
          return (
            <div
              key={k}
              className="image"
              id={object.artwork_url}>
              <li
                style={{
                  display: "inline"
                }}
              >
                <Slider naviType="mobile">
                  {imagesArr.map(function(elem, l) {
                    if (l === imagesArr.length - 1) {
                      return (
                        <div key={l}>
                          <LazyLoad height={window.innerWidth} offset={100}>
                            <div
                              className="youtube-player padding"
                              onClick={() => {
                                obj.labnolIframe(
                                  "youtube_" + k,
                                  object.artwork_video_url
                                );
                              }}
                            >
                              <img
                                id={"youtube_" + k}
                                src={
                                  "/api/viewimage/" +
                                  fnameArr[l] +
                                  "/s=738/" +
                                  imagesArr[l]
                                }
                                className="youtube-image"
                                role="presentation"
                              />
                              <div className="play" />
                            </div>
                          </LazyLoad>
                        </div>
                      );
                    } else {
                      return (
                        <div key={l}>
                          <LazyLoad height={100} offset={100}>
                            <img
                              src={
                                "/api/viewimage/" +
                                fnameArr[l] +
                                "/s=800/" +
                                imagesArr[l]
                              }
                              style={{
                                width: "100%"
                              }}
                              role="presentation"
                            />
                          </LazyLoad>
                        </div>
                      );
                    }
                  })}
                </Slider>

                <div className="image-name">
                  <h2>
                    {'"' + object.artwork_name + '"'}
                  </h2>
                  <p>
                    {object.artwork_description +
                      " " +
                      object.artwork_price +
                      " € " +
                      object.artwork_extra_info}
                    {object.artwork_status === "buy"
                      ? <Link
                          to={
                            "/contact/" +
                            encodeURIComponent(object.artwork_name)
                          }
                        >
                          {" " + object.artwork_status.toUpperCase()}
                        </Link>
                      : <b>
                          {" " + object.artwork_status.toUpperCase()}
                        </b>}
                  </p>
                </div>
              </li>
            </div>
          );
        })}
      </div>
    );
  }
}
export default ArtGalleryMobile;



// WEBPACK FOOTER //
// ./src/components/ArtGalleryMobile.jsx